const REMOTE_USER_PERMISSION_KEYS = {
  ACCESS_RESOURCE_LIBRARY: 'access_resource_library',
  CRUD_POSTS: 'crud_posts',
  CRUD_GOALS: 'crud_goals',
  INIT_BACKGROUND_CHECK: 'init_background_check',
  INIT_MATCH_RUN: 'init_match_run',
  INVEST_IN_GENERAL: 'invest_in_general',
  INVEST_IN_PEERS: 'invest_in_peers',
  JOIN_NETWORKS: 'join_networks',
  MEET_PEERS: 'meet_peers',
  POST_TO_MULTIPLE_TARGETS: 'post_to_multiple_targets',
  VIEW_ALL_TEAMS: 'view_all_teams',
  ACCESS_GROW: 'access_grow',
};

const REMOTE_PROFILE_PERMISSION_KEYS = {
  EDIT_PROFILE: 'edit_profile',
  VIEW_PUBLIC_PROFILE: 'view_public_profile',
  VIEW_PROTECTED_PROFILE: 'view_protected_profile',
  VIEW_PRIVATE_PROFILE: 'view_private_profile',
  VIEW_PROFILE: 'view_profile',
  VIEW_FULL_NAME: 'view_full_name',
  BACKABLE: 'backable',
  CAN_BACK: 'back',
  CAN_PROPOSE: 'propose',
  INVESTABLE: 'investable',
  CAN_INVEST: 'invest',
  CAN_MEET: 'meet',
};

export { REMOTE_USER_PERMISSION_KEYS, REMOTE_PROFILE_PERMISSION_KEYS };
